import {Trans} from '@lingui/macro';
import React, {FC} from 'react';
import styled from 'styled-components';

import {Icon, IconName} from '../../../../libs/shared/ui/src/components/icon/icon';
import {fontSizes, fontWeights} from '../../../../libs/shared/ui/src/styles/fontStyles';
import {PaletteColorsEnum} from '../../../../libs/shared/ui/src/styles/paletteModel';
import {ThemeReader, useUserTheme} from '../../../../libs/shared/ui/src/theme/userThemeProvider';

/*
 * Constants.
 */

export enum InfoBubblePillVariantsEnum {
  EDUCATION = 'education',
  LIGHTNING = 'lightning',
}

const pillColors: {[key in InfoBubblePillVariantsEnum]: ThemeReader} = {
  [InfoBubblePillVariantsEnum.EDUCATION]: (theme) => theme.palette[PaletteColorsEnum.PINK].shade40,
  [InfoBubblePillVariantsEnum.LIGHTNING]: (theme) => theme.greys.shade90,
};

const pillIcons: {[key in InfoBubblePillVariantsEnum]: IconName} = {
  [InfoBubblePillVariantsEnum.EDUCATION]: 'lightbulbTiny',
  [InfoBubblePillVariantsEnum.LIGHTNING]: 'lightningTiny',
};

/*
 * Props.
 */

interface InfoBubblePillProps {
  type: InfoBubblePillVariantsEnum;
}

/*
 * Style.
 */

interface InfoBubbleStyleProps {
  $type: InfoBubblePillVariantsEnum;
}
const StypledInfoBubblePillDiv = styled.div<InfoBubbleStyleProps>`
  margin: 0 0 20px;
  padding: 5px 6px;
  height: 20px;
  width: max-content;
  background-color: ${(p) => pillColors[p.$type](p.theme)};
  border-radius: 100px;
  display: grid;
  grid-column-gap: 4px;
  grid-template-columns: 12px max-content;
  align-items: center;
  color: ${(p) => p.theme.greys.white};
  text-transform: uppercase;
  line-height: 9px;
  font-size: ${fontSizes.veryTiny};
  font-weight: ${fontWeights.bold};
`;

/*
 * Component.
 */

export const InfoBubblePill: FC<InfoBubblePillProps> = ({type}) => {
  const theme = useUserTheme();

  return (
    <StypledInfoBubblePillDiv $type={type}>
      <Icon name={pillIcons[type]} color={theme.greys.white} size={12} />
      {renderText(type)}
    </StypledInfoBubblePillDiv>
  );
};

function renderText(type: InfoBubblePillVariantsEnum) {
  if (type === InfoBubblePillVariantsEnum.EDUCATION) {
    return <Trans id="info-bubble-pill-fronttip">Front Tip</Trans>;
  }

  return <Trans id="info-bubble-pill-lightningtip">Lightning Tip</Trans>;
}
